import React from "react";
import PropTypes from 'prop-types';
// @ts-ignore
import UserIcon from '../../../../../../core/gd-components/icons/user-icon';

import Classes from "classnames";

type Props = {
    companyUser : any
    isSelected  : boolean
    onClick     : callback
}

export default class SearchUserOption extends React.Component<Props> {

    static propTypes = {
        companyUser: PropTypes.object,

        isSelected: PropTypes.bool,

        onClick: PropTypes.func
    }

    onClick = () => {
        if (this.props.onClick) this.props.onClick(this.props.companyUser.id);
    }

    render() {
        const classes = Classes("row", "ui5-list-item", {
            'selected': this.props.isSelected,
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="cell">
                    <div className="title">
                        <div className="icon-22 m-r-10">
                            <UserIcon size="22" userId={this.props.companyUser.user.id} hint={false}/>
                        </div>
                        <div className="ui5-txt-default max-w-250">{this.props.companyUser.user.name}</div>
                    </div>

                </div>
                <div className="cell align-r"/>
            </div>
        )

        /*return (
            <div className={classes} onClick={this.onClick}>
                <UserIcon className="search-item-icon user-icon" size="22" userId={this.props.companyUser.user.id} hint={false}/>
                <div className="search-item-details">
                    <div className="search-item-title">{this.props.companyUser.user.name}</div>
                    {this.props.showCompany && <div className="search-item-company">{this.props.companyUser.company.name}</div>}
                </div>
                <div className="cf"/>
            </div>
        );*/
    }
}
